import React, { useState, useEffect } from "react";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { useFormik } from "formik";
import classNames from "classnames";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { AddCompanyProfileAction, GetCompanyDetailsAction, UpdateCompanyProfileAction } from "../../../redux/actions/companyAction";
import * as Yup from "yup";
import ZbizInput from "../../../components/zbizInput/ZbizInput";
import ZDropdown from "../../../components/zDropdown/ZDropdown";
import { Dropdown } from "primereact/dropdown";
import { handleGetRequest } from "../../../services/GetTemplate";
import Axios from "axios";
import { toast } from "react-toastify";
import { v4 as uuidv4 } from 'uuid';

function AddEditCompanyProfile({ edit, companyId, editable }) {

    const [loading, setloading] = useState(false);
    const [loadingIcon, setloadingIcon] = useState("pi pi-save");
    const [updateFlag, setupdateFlag] = useState(false);
    const [accountNoT24Field, setAccountNoT24Field] = useState(true);
    const [accountNoT24DisableBtn, setAccountNoT24DisableBtn] = useState(true);
    const [segmentsLov, setSegmentsLov] = useState([]);

    const dispatch = useDispatch();
    let history = useHistory();

    const companyProfileData = useSelector((state) => state.companySlice?.companyProfileDetails);

    const getCompanyProfileDetail = async () => {
        await dispatch(GetCompanyDetailsAction("zbizgateway/nonFin/getCompanyDetails/" + companyId));
    };

    useEffect(() => {
        if (companyId !== undefined && companyId !== null && companyId !== "") {
            getCompanyProfileDetail();
        }
    }, []);

    const cancelHandler = (e) => {
        e.preventDefault();
        formik.resetForm();
        history.push("/companyprofilesetup")
    };

    const validationSchema = Yup.object().shape({
        accountNoT24: Yup.string().required("Required").max(30),
        accountTitleT24: Yup.string().required("Required"),
        address: Yup.string().required("Required").max(500),
        // companyCode: Yup.string().required("Company code is required").max(20),
        companyDescription: Yup.string().required("Required").max(500),
        companyName: Yup.string().required("Required").max(200),
        mobileNo: Yup.string().required("Required").matches(/^03\d{9}$/, 'Contact number must start with "03" and be exactly 11 digits'),
        contactNo: Yup.string().nullable().max(11, "Landline number must be at most 11 digits"),
        email: Yup.string().email().required("Required"),
        relationshipManager: Yup.string().required("Required"),
        segment: Yup.string().required("Required"),
    });

    const formik = useFormik({
        validationSchema: validationSchema,
        initialValues: {
            accountNoT24: "",
            accountTitleT24: "",
            address: "",
            // companyCode: "",
            companyDescription: "",
            companyName: "",
            contactNo: "",
            mobileNo: "",
            email: "",
            relationshipManager: "",
            segment: "",
        },
        onSubmit: async (data) => {

            const uuId = uuidv4();
            const uniqueId = uuId.split("-");

            try {
                setloading(true);
                setloadingIcon("pi pi-spin pi-spinner");
                if (updateFlag === false) {
                    data["companyCode"] = formik.values.companyName + "_" + uniqueId[4];
                    const res = await dispatch(AddCompanyProfileAction(data, "zbizgateway/nonFin/saveCompanyProfile"));
                    if (res?.status === 400) {
                        res?.data.forEach((element) => {
                            formik.setFieldError(element?.field, element?.message);
                        });
                        setloading(false);
                    }
                    if (res?.responsecode === 1) {
                        localStorage.setItem("companyIdAdmin", res?.data?.companyId);
                        localStorage.setItem("companyNameAdmin", res?.data?.companyName);
                        history.push("/companydetails" + "?cid=" + res?.data?.companyId); // eslint-disable-line
                    }
                } else {
                    // data["companyProfileId"] = companyProfileData?.companyProfileId;
                    delete data?.createdate
                    delete data?.createuser
                    delete data?.isActive
                    delete data?.lastupdatedate
                    delete data?.lastupdateuser
                    delete data?.updateindex
                    // data["segment"] = 

                    const res = await dispatch(UpdateCompanyProfileAction(data, "zbizgateway/nonFin/updateCompany"));
                    if (res?.status === 400) {
                        res?.data.forEach((element) => {
                            formik.setFieldError(element?.field, element?.message);
                        });
                    } else getCompanyProfileDetail();
                }
            } catch (error) {
                console.log(error);
            } finally {
                setloading(false);
                setloadingIcon("pi pi-save");
            }
        },
    });

    const isFormFieldValid = (name) => !!(formik.touched[name] && formik.errors[name]);
    const getFormErrorMessage = (name) => {
        return isFormFieldValid(name) && <small className="p-error">{formik.errors[name]}</small>;
    };

    const props = { onChange: formik.handleChange, values: formik.values, isFormFieldValid: isFormFieldValid, getFormErrorMessage: getFormErrorMessage };

    const fetchTitle = async () => {
        setAccountNoT24DisableBtn(true);
        setAccountNoT24Field(true)
        const id = toast.loading("Please wait...");
        const data = { accountNoT24: formik.values.accountNoT24 }
        try {
            const response = await Axios({
                method: "post",
                url: `https://zbiz.jsbl.com/zbizgateway/nonFin/validatet24Account/`,
                data: data,
                headers: {
                    "Content-Type": "application/json",
                    Authorization: localStorage.getItem("token"),
                },
            });

            if (response?.data?.responsecode === 1 && response?.data?.data === "No records were found that matched the selection criteria") {
                formik.setFieldValue("accountTitleT24", "");
                formik.setFieldValue("accountNoT24", "");
                // setAccountNoT24DisableBtn(true);
                // setAccountNoT24Field(true)
                toast.update(id, { render: "No records were found that matched the selection criteria", type: "info", isLoading: false, autoClose: 3000 });
                return;
            }

            if (response?.data?.responsecode === 1 && response?.data?.data !== "No records were found that matched the selection criteria") {
                formik.setFieldValue("accountTitleT24", response?.data?.data);
                // setAccountNoT24DisableBtn(true);
                // setAccountNoT24Field(true)
            }

            toast.update(id, { render: response.data.messages, type: "success", isLoading: false, autoClose: 3000 });

        } catch (error) {
            if (error?.response?.data?.message === 'Session Expired') {
                localStorage.clear();
                setTimeout(() => {
                    window.location.href = '/';
                }, 1000);
            }

            if (error?.response?.status === 500) {
                toast.update(id, { render: error?.response?.data?.messages || "Something went wrong !!", type: "error", isLoading: false, autoClose: 3000 });
            } else if (error?.response?.status === 400) {
                toast.update(id, { render: error?.response?.data?.[0]?.toastError || "Something went wrong !!", type: "error", isLoading: false, autoClose: 3000 });
            } else {
                toast.update(id, { render: error?.response?.data?.messages || "Something went wrong !!", type: "warn", isLoading: false, autoClose: 3000 });
            }

            throw error;
        }
    };

    // const fetchTitle = async () => {
    //     const data = { accountNoT24: formik.values.accountNoT24 }
    //     try {
    //         const response = await Axios({
    //             method: "post",
    //             url: `http://dev.mfscode.com/zbizgateway/nonFin/validatet24Account/`,
    //             data: data,
    //             headers: {
    //                 "Content-Type": "application/json",
    //                 Authorization: localStorage.getItem("token"),
    //             },
    //         });
    //         if (response?.responsecode === 1) {
    //             formik.setFieldValue("accountTitleT24", response?.data);
    //             setAccountNoT24DisableBtn(true)
    //         }
    //     } catch (error) {
    //         console.log(error);
    //         // formik.setFieldValue("accountTitleT24FetchResponseCode", error?.response?.data?.responsecode);
    //         formik.setFieldValue("accountTitleT24", "");
    //     }
    // };

    const handleFieldView = () => {
        formik.setFieldValue("accountTitleT24", "")
        formik.setFieldValue("accountNoT24", "")
        setAccountNoT24DisableBtn(false)
        setAccountNoT24Field(false)
    }

    const getSegmentsLov = async () => {
        setloading(true);
        const res = await handleGetRequest(
            "zbizgateway/lov/lovSegment"
        );
        setSegmentsLov(res?.data);
        setloading(false);
    };

    // useEffect(() => {
    //     if (formik.values.accountNoT24) {
    //         setAccountNoT24DisableBtn(false)
    //     }
    // }, [formik.values.accountNoT24]);

    useEffect(() => {
        if (companyProfileData && companyProfileData !== null && companyProfileData !== undefined && edit) {
            setupdateFlag(true);
            const rowData = JSON.parse(JSON.stringify(companyProfileData));
            const keys = Object.keys(rowData);
            keys.forEach((item) => {
                formik.setFieldValue(`${item}`, rowData[item]);
                formik.setFieldValue("segment", rowData?.segment?.segmentId.toString());
            });
        }
    }, [companyProfileData]);

    useEffect(() => {
        getSegmentsLov()
    }, []);

    return (
        <div>
            <div className="page_header">
                <div className="Top__Btn" style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                    <div className="d_align">
                        <i className="pi pi-arrow-circle-left mr-1" onClick={() => history.goBack()} />
                        <h3 className="mod_heading">{`${editable === "true" ? "Update Company" : editable === "view" ? "Company Details" : "Add Company"} `}</h3>
                    </div>
                </div>
            </div>
            <div className="card Card__Round">
                <form onSubmit={formik.handleSubmit} className="p-fluid p-mt-2 pos_relative">
                    <div className="p-fluid p-formgrid p-grid">
                        <div className="p-field p-col-12 p-md-4">
                            <div className="p-field input_cp pos_relative">
                                <label htmlFor="companyName" className={classNames({ "p-error": isFormFieldValid("companyName") }, "Label__Text")}>
                                    Company Name<span className="Label__Required">*</span>
                                </label>
                                <InputText id="companyName" placeholder="Enter Company Name" name="companyName" value={formik.values.companyName} onChange={formik.handleChange} className={classNames({ "p-invalid": isFormFieldValid("companyName") }, "input_text")} keyfilter={/^[a-zA-Z0-9_\s]*$/} style={{ "pointerEvents": "none !important" }} />
                                {getFormErrorMessage("companyName")}
                            </div>
                        </div>
                        {/* <div className="p-field p-col-12 p-md-4">
                        <div className="p-field">
                            <ZbizInput label="Company Code" required keyName="companyCode" placeholder="Enter Company Code" {...props} keyfilter={/^[a-zA-Z0-9_]*$/} />
                        </div>
                    </div> */}
                        <div className="p-field p-col-12 p-md-4">
                            <div className="p-field input_cp">
                                <ZbizInput label="Company Description" required keyName="companyDescription" placeholder="Enter Company Description" {...props} />
                            </div>
                        </div>
                        <div className="p-field p-col-12 p-md-4">
                            <div className="p-field input_cp">
                                {/* <ZbizInput label="Account No T24" required keyName="accountNoT24" placeholder="Enter Account No T24" {...props} keyfilter={/^[a-zA-Z0-9_]*$/} disabled={accountNoT24DisableBtn} /> */}
                                <label className="Label__Text">Account No T24 <span style={{ "color": "red" }}>*</span></label>
                                <div style={{ "display": "flex", "alignItems": "center" }}>
                                    <InputText id="accountNoT24" name="accountNoT24" value={formik.values.accountNoT24} onChange={formik.handleChange} placeholder="Enter Account No T24" keyfilter={/^[a-zA-Z0-9_]*$/} disabled={accountNoT24Field} className="input_text" />
                                    <i className="pi pi-pencil" onClick={handleFieldView} style={{ "marginLeft": "10px", "cursor": "pointer" }} />
                                </div>
                                {
                                    editable === "true" || editable == undefined ? (<Button type="button" label="Fetch title" onClick={fetchTitle} className="Btn__Transparent p-mt-2" disabled={accountNoT24DisableBtn} />) : ""
                                }
                            </div>
                        </div>
                        <div className="p-field p-col-12 p-md-4">
                            <div className="p-field input_cp">
                                <ZbizInput disabled label="Account Title" required keyName="accountTitleT24" placeholder="" {...props} />
                            </div>
                        </div>
                        <div className="p-field p-col-12 p-md-4">
                            <div className="p-field input_cp">
                                <ZbizInput label="Address" required keyName="address" placeholder="Enter Address" {...props} keyfilter={/^[a-zA-Z0-9_\s]*$/} />
                            </div>
                        </div>
                        <div className="p-field p-col-12 p-md-4">
                            <div className="p-field input_cp">
                                <ZbizInput label="Landline No" keyName="contactNo" placeholder="Enter Contact No" {...props} type="number" keyfilter={/^[0-9]\d*$/} />
                            </div>
                        </div>
                        <div className="p-field p-col-12 p-md-4">
                            <div className="p-field input_cp">
                                <ZbizInput label="Mobile No" required keyName="mobileNo" placeholder="03XXXXXXXXX" {...props} keyfilter={/^[0-9]+$/} />
                            </div>
                        </div>
                        <div className="p-field p-col-12 p-md-4">
                            <div className="p-field input_cp">
                                <ZbizInput label="Email" required keyName="email" placeholder="Enter Email" {...props} />
                            </div>
                        </div>
                        <div className="p-field p-col-12 p-md-4">
                            <div className="p-field input_cp">
                                {/* <ZDropdown {...props} label="Relationship Manager" required valueOption="id" keyName="relationshipManager" placeholder="Select" optionLabel="description" url="zbizgateway/lov/lovRelationshipManager" /> */}
                                <label htmlFor="companyName" className={classNames({ "p-error": isFormFieldValid("companyName") }, "Label__Text")}>
                                    Relationship Manager<span className="Label__Required">*</span>
                                </label>
                                <InputText id="relationshipManager" placeholder="Enter Company Name" name="relationshipManager" value={formik.values.relationshipManager} onChange={formik.handleChange} className={classNames({ "p-invalid": isFormFieldValid("relationshipManager") }, "input_text")} keyfilter={/^[a-zA-Z0-9_\s]*$/} style={{ "pointerEvents": "none !important" }} />
                            </div>
                        </div>
                        <div className="p-field p-col-12 p-md-4">
                            <div className="p-field input_cp">
                                <label htmlFor="segment" className={classNames({ "p-error": isFormFieldValid("segment") }, "Label__Text")}>
                                    Segment<span className="Label__Required">*</span>
                                </label>
                                <Dropdown placeholder="Select Segment" id="segment" options={segmentsLov} optionLabel="code" optionValue="id" name="segment" value={formik.values.segment} onChange={formik.handleChange} className={classNames({ "p-invalid": isFormFieldValid("segment") }, "Dropdown__Round")} />
                                {getFormErrorMessage("segment")}
                            </div>
                        </div>
                        {/* <div className="p-field p-col-12 p-md-4">
                        <div className="p-field">
                            <ZbizInput label="Account No Micro Bank" required keyName="accountNoMb" placeholder="Enter Account No MB" {...props} />
                        </div>
                    </div> */}
                    </div>

                    {
                        editable && editable === "view" ? (<div className="overlay_field"></div>) : ""
                    }

                    {editable === "true" ? (
                        <div className="GenerateDown__Btn p-mt-4">
                            <Button disabled={loading} label={updateFlag ? "Update" : "Add"} className="Btn__Transparent" />
                            <Button label="Cancel" className="Btn__Dark" onClick={(e) => cancelHandler(e)} />
                        </div>
                    ) : null}
                    {editable === undefined ? (
                        <div className="GenerateDown__Btn p-mt-4">
                            <Button disabled={loading} label={updateFlag ? "Update" : "Add"} className="Btn__Transparent" />
                            <Button label="Cancel" className="Btn__Dark" onClick={(e) => cancelHandler(e)} />
                        </div>
                    ) : null}
                </form>
            </div>
        </div>
    );
}

export default AddEditCompanyProfile;
